// Minimalist loading indicator — a thin dual-ring spinner in the app palette.
export const Loader = ({ label = "Memuat…", full = false, className = "" }) => (
  <div
    data-testid="app-loader"
    className={
      (full
        ? "fixed inset-0 z-50 grid place-items-center bg-white/70 backdrop-blur-sm"
        : "grid place-items-center py-20") + " " + className
    }
  >
    <div className="flex flex-col items-center gap-3">
      <span className="relative block h-10 w-10">
        <span className="absolute inset-0 rounded-full border-2 border-slate-200" />
        <span className="absolute inset-0 rounded-full border-2 border-transparent border-t-emerald-600 animate-spin" />
      </span>
      {label && (
        <span className="text-xs font-medium tracking-wide text-slate-500 animate-pulse">{label}</span>
      )}
    </div>
  </div>
);

// Lightweight table skeleton rows for perceived-speed while data loads.
export const TableSkeleton = ({ rows = 6, cols = 5 }) => (
  <div className="divide-y divide-slate-100" data-testid="table-skeleton">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex gap-4 px-4 py-3.5">
        {Array.from({ length: cols }).map((_, c) => (
          <div
            key={c}
            className="h-4 rounded bg-slate-100 animate-pulse"
            style={{ width: `${[28, 22, 18, 16, 16][c % 5]}%` }}
          />
        ))}
      </div>
    ))}
  </div>
);

export default Loader;
